import React from "react";
import Select from "react-select";
/**
 * Select2 wrapper using react-select.
 * Maintains the same props as the original jQuery-based version.
 */
const Select2 = ({
  options = [],
  value,
  onChange,
  placeholder = "Select option",
  multiple = false,
  disabled = false,
  className = "",
  id,
  allowClear = true,
}) => {
  // Helper: find option object by value
  const getOption = (val) => options.find((opt) => opt.value === val);
  const getOptions = (vals) =>
    Array.isArray(vals) ? vals.map((v) => getOption(v)).filter(Boolean) : [];
  // Convert the external value(s) to react-select's expected format
  const selectedValue = multiple
    ? getOptions(value) // array of option objects
    : value
      ? getOption(value) // single option object or null
      : null;
  // Handle change events from react-select
  const handleChange = (selectedOption) => {
    if (!onChange) return;
    if (multiple) {
      // selectedOption is an array of option objects
      const values = selectedOption
        ? selectedOption.map((opt) => opt.value)
        : [];
      onChange(values);
    } else {
      // selectedOption is a single option object or null
      onChange(selectedOption ? selectedOption.value : null);
    }
  };
  return (
    <Select
      id={id}
      className={className}
      classNamePrefix="react-select"
      options={options}
      value={selectedValue}
      onChange={handleChange}
      placeholder={placeholder}
      isClearable={allowClear}
      isMulti={multiple}
      isDisabled={disabled}
    />
  );
};
export default Select2;
